module.exports = __webpack_public_path__ + "static/img/Załącznik nr 7 - warunki prowadzenia zajęć eT+ dla lektorów-1.54eb09f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Załącznik nr 7 - warunki prowadzenia zajęć eT+ dla lektorów-1.png
// module id = eWzL
// module chunks = 0